export default "__VITE_ASSET__cf007920__"